import styled from "styled-components";
import Modal from "react-modal";
export const Container = styled.div`
   flex: 1;
  overflow-y: auto;
  padding-right: 1rem;
  display: flex;
  flex-direction: column; 
  gap: 2rem;

.title{

    h1{
        font-weight: 600;
    }
}

    .dietary-choice-container{
    display: flex;
    flex-wrap: wrap;
    gap: 3rem;
    width: 100%;
    padding: 0 2rem;

}

.dietaries{
    display: flex;
    gap: 1rem;
    @media (max-width: 768px) {
        flex-wrap: wrap;
        gap: 2rem;
    }
}

.cart{
    display: flex;
    flex-direction: column;
    gap: 2rem;

    h1{
        display: list-item;
    }

    li{
        font-size: 1.8rem;
    }
}
.top-cart{
    padding-bottom: 3rem;
    border-bottom: 2px solid #808D9E33;
}

.top-cart , .bottom-cart{
    display: flex;
    flex-direction: column;
    gap: 4rem;
}

`

export const Status = styled.span`
padding: 0.5rem 1rem !important;
border-radius: 0.5rem;
background-color: #209A421A;
color:  var(--primary);
font-size: 1.8rem;
white-space: nowrap;

`
export const StyledReactModal = styled(Modal)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 3rem;
  padding: 2rem;
  width: 80rem;
  max-height: 90vh;
  overflow: hidden; /* prevent overflow from modal box itself */
  background: white;
  outline: none;
  
  display: flex;
  flex-direction: column;

  @media (max-width: 500px) {
    width: 90%;
    padding: 1.5rem;
  }
`;
